import { MODAL_OPEN, MODAL_CLOSE, MODAL_SET } from "../const";

export const openModal = () => {
  return {
    type: MODAL_OPEN,
  };
};

export const closeModal = () => {
  return {
    type: MODAL_CLOSE,
  };
};

export const setModal = (header: string, body: string) => {
  return {
    type: MODAL_SET,
    payload: {header, body},
  };
};